<form class="wrapper"
      [style.min-width.px]="minWidthPx"
      *ngrxLet="viewModel$; let model">
  @if (model.dropdownOptions.length) {

    <div class="stickyHeader"
         #header
         [ngClass]="{ 'pt-2': !searchFieldHidden }">

      <div class="flex">
        <!-- 'Select all' wrapper -->
        <!-- clicking the wrapper triggers a click ev on the checkbox and the click ev on the checkbox -->
        <!-- itself is stopped - makes sure the wrapper's entire area is used to trigger the toggle func -->
        <div class="cursor-pointer"
             (click)="selectAllCheckbox._inputElement.nativeElement.click()">
          <mat-checkbox
              #selectAllCheckbox
              [checked]="isToggleAllChecked(model.filteredOptions)"
              [indeterminate]="isToggleAllIndeterminate(model.filteredOptions)"
              [disabled]="!model.filteredOptions.length"
              (click)="$event.stopPropagation()"
              (change)="toggleSelectAll($event.checked, model.filteredOptions)"
              disableRipple>

            @if (searchFieldHidden) {
              <span>{{
                  'MULTISELECT.' + (searchFC.value?.trim().length > 0 &&
                  (isToggleAllIndeterminate(model.filteredOptions) || !isToggleAllChecked(
                      model.filteredOptions))
                      ? 'SELECT_ALL_CONTAINING'
                      : 'SELECT_ALL') | translate: {
                    searchKeyword: searchFC.value?.trim()
                  }
                }}
            </span>
            }
          </mat-checkbox>

        </div>

        <!-- Search-field for dropdown-option-search -->
        @if (!searchFieldHidden) {
          <mat-form-field id="search-form"
                          appearance="fill">
            <mat-icon svgIcon="search" matPrefix
                      [class.text-primary]="searchFC.value?.trim().length"></mat-icon>
            <input matInput appGxInput
                   [formControl]="searchFC"
                   (keydown)="$event.stopPropagation()"
                   [placeholder]="'MULTISELECT.SEARCH' | translate">
            <button mat-icon-button matSuffix
                    [class.invisible]="!searchFC.value?.length"
                    aria-label="Clear"
                    (click)="resetSearch()">
              <mat-icon svgIcon="close"></mat-icon>
            </button>
          </mat-form-field>
        }
      </div>

      <mat-divider [ngClass]="{'mt-2': !searchFieldHidden}"></mat-divider>

    </div>

    <!-- Dropwdown options -->
        <!-- clicking the wrapper triggers a click ev on the checkbox and the click ev on the checkbox -->
        <!-- itself is stopped - makes sure the wrapper's entire area is used to trigger the toggle func -->
        <!-- min/max buffer set to same value as default values caused some weird scrollbar stutter -->
    <cdk-virtual-scroll-viewport [itemSize]="itemSize"
                                 [minBufferPx]="4*itemSize"
                                 [maxBufferPx]="4*itemSize"
                                 [style.height.px]="getDropdownHeight(model.filteredOptions)"
                                 class="scrollable"
                                 #viewport>
      <div *cdkVirtualFor="let option of model.filteredOptions; trackBy: trackByFn"
           #checkboxWrapper
           class="cursor-pointer hover:bg-neutral-90 pr-4"
           [matTooltip]="option.name"
           [matTooltipShowDelay]="2000">
        <mat-checkbox [checked]="isChecked(option.value)"
                      (change)="onCheckboxChange(option.value, $event)">
          @if (showCountryFlag) {
            <span #flagContainer
                  class="flagContainer"
                  [style.padding-right.px]="flagContainer.clientWidth ? 8 : 0">{{ option.value | flagEmoji }}</span>
            <!--          max-width needed for truncate to work.. wrapper-width - 16px right-padding -
                        40px checkbox-width - 4px label left-padding (- flagContainer width)-->
            <span
                [style.max-width.px]="checkboxWrapper.clientWidth - 60 - flagContainer.clientWidth"
                class="truncate block"
                [innerHTML]="option.name | highlightKeyword: searchFC.value?.trim()">
            </span>
          } @else {
            <span [style.max-width.px]="checkboxWrapper.clientWidth - 60"
                  class="truncate block"
                  [innerHTML]="option.name | highlightKeyword: searchFC.value?.trim()">
            </span>
          }
        </mat-checkbox>
      </div>
    </cdk-virtual-scroll-viewport>

  } @else {
  <span class="pl-10 w-full">nothing to select from...</span>
  }

</form>
